export default {
  'PENDING'  : 'PENDING',
  'DONE'     : 'DONE',
  'CANCELLED': 'CANCELLED'
};